module.exports = __webpack_public_path__ + "img/vegetables.1b74ea81.jpg";